import { actionTypes } from '../../../controller';
import { settingBackground } from '../../../lib/root-background';

const { FETCH_PLATFORM_SETTING_SUCCESS } = actionTypes;

export function setPlatformSettingMiddleware() {
	return next => action => {
		const { type, setting } = action;

		if (type === FETCH_PLATFORM_SETTING_SUCCESS) {
			localStorage.setItem('clientVisual', JSON.stringify(setting.clientVisual));
			settingBackground(setting.clientVisual);

			// TODO: couldLoginViaId has same issue, but no bugging now
			// localStorage.setItem('clientCouldLoginViaId', setting.couldLoginViaId);
		}

		next(action);
	};
}
